import {IBenefit} from '@dazn/lp-web/src/types/benefits.types';
import {getImage} from '@dazn/lp-web/src/utils';

export function supportedDevices(component: any) {
    if (!component) return;

    const devices = [] as IBenefit[];
    let supportedDeviceFooter = '' as any;
    let supportDeviceHeader = '' as any;
    component?.fields?.entries?.forEach(({fields, sys}: any) => {
        if (sys?.contentType?.sys?.id === 'LPContentItem') {
            devices.push({
                title: fields.title,
                description: fields.description,
                logo: getImage(fields?.logo)
            });
        } else if (sys?.contentType?.sys?.id === 'CommonKeyValue') {
            if (fields?.key === 'supportedDeviceHeader') {
                supportDeviceHeader = fields?.value;
            } else if (fields?.key === 'supportedDeviceFooter') {
                supportedDeviceFooter = fields?.value;
            }
        }
    });

    return {
        title: component?.fields?.title ?? '',
        description: component?.fields?.description ?? '',
        devices,
        componentType: component?.fields?.componentType,
        supportedDeviceFooter,
        supportDeviceHeader
    };
}
